// Soulfunnyness Baby Co — Shopify Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Smooth scroll for nav links ──
  document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ── Modal ──
  var overlay  = document.getElementById('sf-modal-overlay');
  var formView = document.getElementById('sf-modal-form');
  var succView = document.getElementById('sf-modal-success');
  var form     = document.getElementById('sf-modal-form-el');

  function openModal() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    // reset after transition
    setTimeout(function () {
      formView.style.display = '';
      succView.style.display = 'none';
      if (form) form.reset();
    }, 280);
  }

  // Open triggers
  document.querySelectorAll('[data-open-modal]').forEach(function (el) {
    el.addEventListener('click', openModal);
  });

  // Close on overlay click
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  // Close button
  document.getElementById('sf-modal-close').addEventListener('click', closeModal);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Form submit
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('[name="contact[email]"]').value;
      if (!email) return;
      // Show success screen
      formView.style.display = 'none';
      succView.style.display = 'block';
      setTimeout(closeModal, 2200);
    });
  }

});
